// extracted by mini-css-extract-plugin
export var ignore = "_6s-1";
export var mapping = "_6s-0";
export var range = "_6s-4";
export var savings = "_6s-3";
export var settings = "_6s-2";